import { render } from "./SendWithMessageModal.vue?vue&type=template&id=35e92a6a"
import script from "./SendWithMessageModal.vue?vue&type=script&lang=js"
export * from "./SendWithMessageModal.vue?vue&type=script&lang=js"

import "./SendWithMessageModal.vue?vue&type=style&index=0&id=35e92a6a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__